import { useState, useEffect, useCallback } from 'react'
import {
  getUserSubscriptions,
  updateSubscriptionPreferences,
  completeSubscriptionPayment,
  cancelSubscription,
} from '../api/library'

export function useUserSubscriptions() {
  const [subscriptions, setSubscriptions] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    setError(null)

    getUserSubscriptions()
      .then((data) => {
        if (!cancelled) setSubscriptions(data)
      })
      .catch((err) => {
        if (!cancelled) setError(err.message)
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [])

  const updatePreferences = useCallback(async (id, preferences) => {
    const updated = await updateSubscriptionPreferences(id, preferences)
    setSubscriptions((prev) =>
      prev.map((sub) => (sub.id === id ? updated : sub))
    )
    return updated
  }, [])

  const completePayment = useCallback(async (id) => {
    const result = await completeSubscriptionPayment(id)
    return result
  }, [])

  const cancel = useCallback(async (id) => {
    const updated = await cancelSubscription(id)
    setSubscriptions((prev) =>
      prev.map((sub) => (sub.id === id ? updated : sub))
    )
    return updated
  }, [])

  return { subscriptions, loading, error, updatePreferences, completePayment, cancel }
}
